import { displayModes } from 'services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 3,
    columns: {
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4,
      },
      stopType: {
        columnName: Columns.stopType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5,
      },
      name: {
        columnName: Columns.name.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 6,
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 7,
      },
    }
  },
  [displayModes.carrier]: {
    version: 3,
    columns: {
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4,
      },
      stopType: {
        columnName: Columns.stopType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5,
      },
      name: {
        columnName: Columns.name.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 6,
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 7,
      },
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
}

export default DefaultConfig;